import { PRIMARY_COLOR } from "@/lib/utils";

/** The colors the apps offer for a list, in picker order. */
export const LIST_COLORS = [
  PRIMARY_COLOR, // 🔴 Primary Red (Unchanged as requested)
  "#ff7b00", // 🟠 Vibrant Orange (Pure, highly saturated, distinct from Red)
  "#ffb400", // 🟡 Vivid Amber (Bright yellow-orange for good dark mode contrast)
  "#ffdd00", // ☀️ Bright Yellow (Maximum brightness/saturation for dark mode legibility)
  "#caff00", // 🍋 Neon Lime (Vibrant, high-luminance yellow-green)
  "#77ff00", // 🍏 Vibrant Spring Green (Bright yellow-green)
  "#00b300", // 🌲 Electric Green (Revised: Richer, darker, and distinctly different from the lighter green)
  "#00d8d8", // 💎 Vibrant Cyan (Bright aqua/cyan, maximum distinction from blue)
  "#0098a8", // 🌊 Deep Teal (Rich, medium-dark blue-green)
  "#0088ff", // 🔵 Electric Blue (Bright and highly saturated pure blue)
  "#3b58c7", // 🛡️ Royal Blue (Deeper, classic blue for light mode contrast)
  "#6a3eff", // 🟣 Vibrant Indigo (Bright blue-purple)
  "#a239ff", // 🔮 Rich Purple (Deep, high-saturation purple)
  "#ff29e8", // 🩷 Vivid Magenta (Bright, pure pink-purple)
  "#ff008a", // 💖 Hot Pink (Saturated fuchsia, connects back to the red hue)
];
